import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { getSession, isAdmin } from "@/lib/api";
import { getLang } from "@/lib/i18n";
import Home from "@/pages/Home";
import JudgeLogin from "@/pages/JudgeLogin";
import JudgeList from "@/pages/JudgeList";
import ScoreCard from "@/pages/ScoreCard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PublicResults from "@/pages/PublicResults";
import Registration from "@/pages/Registration";
import Announcer from "@/pages/Announcer";
import NowOnStage from "@/pages/NowOnStage";
import Diplomas from "@/pages/Diplomas";
import StartList from "@/pages/StartList";
import Signup from "@/pages/Signup";
import Organization from "@/pages/Organization";
import SignupsAdmin from "@/pages/SignupsAdmin";
import { VersionWatcher } from "@/components/fly/VersionWatcher";

const LOGIN = { admin: "/admin/login", judge: "/sedzia/login", registrar: "/rejestracja/login", announcer: "/konferansjer/login", diploma: "/dyplomy/login" };

const Guard = ({ role, children }) => {
  const s = getSession();
  if (!s || s.role !== role) return <Navigate to={LOGIN[role]} replace />;
  return children;
};

// evaluated on every render (not once at App mount) so in-SPA login/logout is respected
const RequireLogin = ({ children }) => (isAdmin() ? children : <Navigate to="/admin/login" replace />);
const PUBLIC = ["/", "/wyniki", "/teraz-na-scenie", "/lista-startowa", "/zapisy"];
const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.lang = PUBLIC.includes(pathname) ? getLang() : "pl";
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App fly-bg fly-grain">
      <BrowserRouter>
        <ScrollTop />
        <VersionWatcher />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wyniki" element={<PublicResults />} />
          <Route path="/teraz-na-scenie" element={<NowOnStage />} />
          <Route path="/sedzia/login" element={<JudgeLogin key="judge" />} />
          <Route path="/sedzia" element={<Guard role="judge"><JudgeList /></Guard>} />
          <Route path="/sedzia/ocena/:id" element={<Guard role="judge"><ScoreCard /></Guard>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/rejestracja/login" element={<JudgeLogin kind="registrar" />} />
          <Route path="/rejestracja" element={<Guard role="registrar"><Registration /></Guard>} />
          <Route path="/konferansjer/login" element={<JudgeLogin key="announcer" kind="announcer" />} />
          <Route path="/konferansjer" element={<Guard role="announcer"><Announcer /></Guard>} />
          <Route path="/lista-startowa" element={<StartList />} />
          <Route path="/organizacja" element={<RequireLogin><Organization /></RequireLogin>} />
          <Route path="/organizacja/zapisy" element={<Guard role="admin"><SignupsAdmin /></Guard>} />
          <Route path="/logowanie" element={<Navigate to="/admin/login" replace />} />
          <Route path="/zapisy" element={<Signup />} />
          <Route path="/dyplomy/login" element={<JudgeLogin key="diploma" kind="diploma" />} />
          <Route path="/dyplomy" element={<Guard role="diploma"><Diplomas /></Guard>} />
          <Route path="/admin" element={<Guard role="admin"><AdminDashboard /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
